import {ValidationModel} from '../../../shared/models/validation-results/validation.model';

export class DisbursementSummarySearchCriteriaModel extends ValidationModel {
    // Gets or sets the GetOpenFuelTaxDisbursements flag.
    // If true, the search will return ALL open fuel tax disbursements, and will ignore all other search criteria.
    public getOpenFuelTaxDisbursements: boolean;

    /// Gets or sets the finance disbursement request id.
    /// If set, the search will only return the disbursement specified by this id, and will ignore all other search criteria.
    public financeDisbursementRequestId: number;

    /// Gets or sets the finance disbursement request id.
    /// If set, the search will only return the disbursement specified by this order number, and will ignore all other search criteria.
    public orderNumber: number;

    // Gets or sets the finance disbursement request type id
    public financeDisbursementRequestTypeId: number;

    // Gets or sets the finance disbursement request status type id
    public financeDisbursementRequestStatusTypeId: number;

    // Gets or sets the customer number id
    public customerNumberId: number;

    // Gets or sets the assigned to user id
    public assignedToUserId: number;

    // Gets or sets the start date
    public startDate: Date;

    // Gets or sets the end date
    public endDate: Date;

    /// Gets or sets a value indicating which dates exactly the start date and end date correspond to.
    public dateRangeTypeId: number;

    // Gets or sets the fiscal year id for the start date to use to search against the Fuel Tax Refund period
    public startPeriodFiscalYearId: number;

    // Gets or sets the fiscal year id for the start date to use to search against the Fuel Tax Refund period
    public endPeriodFiscalYearId: number;
}
